// Core
import React from 'react';
import PropTypes from 'prop-types';

// Assets
import { Alert, Snackbar } from '@mui/material';

// Renders the `errorAlert` state from useAlert()
const AlertSnackbar = ({ alert }) => {
  if (!alert || !alert.open) return null;
  return (
    <Snackbar open={alert.open} autoHideDuration={3000}>
      <Alert severity={alert.severity} sx={{ width: '100%' }}>
        {alert.msg}
      </Alert>
    </Snackbar>
  );
};

export default AlertSnackbar;

AlertSnackbar.propTypes = {
  alert: PropTypes.shape({
    msg: PropTypes.string,
    open: PropTypes.bool,
    severity: PropTypes.string
  })
};
